import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../components/ContentSlider/css/contentSlider.scss';
import '../../../pages/doctube/doctubeProfileManagement/scss/dt_profile.scss';
import '../../../pages/doctube/doctubeProfileManagement/scss/dt_profileRight.scss';
// import { DoctubeSupport } from '../../../components/icons';

import { Skeleton } from '../../Skeleton';
// import { DoctubeSupport } from '../../../../../components/icons';

const SheduleSectionSkeleton = () => {
  return (
    <>
      <div className="w-100 dt_Support position-relative mb-5">
        <div className="rightCardGraph position-absolute top-0 end-0">
          <span className="graphBigCircle position-absolute bg-primary rounded-circle bg-opacity-10"></span>
        </div>
        <div className="dt_SupportTop d-flex justify-content-between align-items-center gap-4">
          <Skeleton variant="text" width={80} height={150} />
          <div className="dt_SupportText text-start">
            <h5 className="fs-4 fw-normal text-black mb-2">
              <Skeleton variant="text" width={200} height={20} />
            </h5>
            <h4 className="fs-16 fw-semibold text-black">
              <Skeleton variant="text" width={100} height={20} />
            </h4>
          </div>
        </div>
        <div className="dt_SupportBtm position-relative">
          <div className="d-flex justify-content-center align-items-center gap-4">
            <Skeleton variant="text" width={90} height={60} />{' '}
            <Skeleton variant="text" width={90} height={60} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SheduleSectionSkeleton;
